import { Navigate, useLocation } from "react-router-dom";

import Layout from "layout/Layout";

import { useEffect, useState } from "react";
import { useUser } from "stores/useUser";
import { isSourceExtension } from "utils/common";
import LoaderScreen from "components/Loader";
import { FirebaseAuth, FirestoreDB } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

export function RequireAuth() {
  const location = useLocation();
  const { user , setUser } = useUser();
  const [loading, setLoading] = useState(true);

  // Step 1: Check if user has basic authentication (account created)
  const hasAccount = user?.uid ? true : false;

  // Step 2: Check if user has calendar connected
  const hasCalendar = user?.credentials?.refreshToken;

  const source = isSourceExtension(location.pathname) ? "extension" : null;

  const getUser = async (id) => {
    console.log("RequireAuth -> getUser -> id", id);
    const responseUser = await getDoc(doc(FirestoreDB, "users", id));
    if (responseUser.exists()) {
      return responseUser.data();
    }
  }

  useEffect(() => {
    const unsubscribe = FirebaseAuth?.onAuthStateChanged(
      async (user) => {
        if (user) {
          const userInfo = await getUser(user.uid);
          await Promise.resolve(setUser(userInfo));
        } else {
          console.log("User is not authenticated");
        }
        setLoading(false);
      },
      (err) => {
        console.log(err.message);
      }
    );

    unsubscribe();
  }, []);

  if (loading) {
    return <LoaderScreen />;
  }

  // Step 1: Redirect to login if no account
  if (!hasAccount) {
    return <Navigate to="/login" state={{ from: location, source }} />;
  }

  // Step 2: Redirect to calendar onboarding if account exists but no calendar
  if (!hasCalendar) {
    console.log("User account exists but calendar not connected - redirecting to onboarding");
    return <Navigate to="/onboarding-calendar" state={{ from: location }} />;
  }

  // Step 3: Check subscription - but pass flag to indicate we need to check org first
  if (!user.subscription?.plan) {
    console.log("User needs to select subscription plan - will check for organization");
    return <Navigate to="/subscription" state={{ checkOrganization: true }} />;
  }

  return (
    // defining layout, all the routes are going to be nested inside this layout, also EVENTS data is fetched in layout
    <Layout source={source} />
  );
}
